import './BatteryList.scss'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Alert, Card, Col, Container, Form, ListGroup, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Batteries } from '../../api/Batteries';
import { useNavigate } from 'react-router-dom';
import AppLoader from '../../components/AppLoader';
import AppSearch from '../../components/AppSearch';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useToasts } from '../../contexts/toasts';
import { Battery } from '../../models/Battery';

export default function BatteriesList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [batteries, setBatteries] = useState<Battery[] | null>();

  const [searchText, setSearchText] = useState<string>("");

  const { showLoader, hideLoader } = useFullScreenLoader();
  const { showToast } = useToasts();

  useEffect(() => {
    initBatteries();
    // eslint-disable-next-line
  }, []);

  const handleCheckedBattery = (batteryIndex: number) => (evt: React.ChangeEvent<any>) => {

    const value = evt.target.checked;

    let updatedBatteries = [...batteries!]
    updatedBatteries[batteryIndex].checked = value;

    setBatteries([...updatedBatteries])

  }

  const handleSearchChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = evt.target.value;
    setSearchText(value);
  }

  const initBatteries = () => {
    showLoader!();
    Batteries.getTenantBatteries()
      .then(
        ({ data: batteries }) => {
          batteries.map((p) => { p.checked = false; return p });
          setBatteries(batteries)
          hideLoader!();
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          hideLoader!();
          showToast!('batteries-error', message, `Batteries Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }

  const renderBatteries = () => {
    const filteredBatteries = batteries!.filter(battery => battery.name.toLowerCase().includes(searchText.toLowerCase()));

    return (
      <>
        <Row className="gx-2 mb-3">
          <Col>
            <AppSearch value={searchText} onChange={handleSearchChange} placeholder={t('batteriesList.search')} />
          </Col>
        </Row>

        {filteredBatteries.length === 0 && (
          <Alert className="mb-0 py-2">
            <FontAwesomeIcon icon={solid('info-circle')} />
            <span className="ms-2">{t('batteriesList.noBatteries')}</span>
          </Alert>
        )}

        {batteries!.filter(p => p.checked).length > 0 &&
          <Alert className="mb-2 py-2">
            <FontAwesomeIcon icon={solid('info-circle')} />
            <span className="ms-2">{t('batteriesList.selectedBatteries')} {batteries!.filter(p => p.checked).length}</span>
          </Alert>
        }

        <ListGroup>
          {filteredBatteries.map((battery, index) => (
            <ListGroup.Item key={battery.id} className="d-flex align-items-center">
              <div className="pe-3">
                <Form.Check
                  inline
                  className='ms-3'
                  id={String(battery.id)}
                  type="checkbox"
                  checked={battery.checked}
                  onChange={handleCheckedBattery(index)}
                />
              </div>

              <Col className="overflow-hidden">
                <p className="mb-0 highlight h6" onClick={() => navigate(`/tenant-batteries/${battery.id}/details`)}> {battery.name}</p>
                <p className="text-truncate mb-0">{battery.code}</p>
                <p className="text-truncate mb-0">{battery.description}</p>
              </Col>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </>
    )
  }

  const renderAsyncContent = () => {
    return batteries
      ? renderBatteries()
      : (
        <div className="d-flex justify-content-center py-5">
          <AppLoader size={150} />
        </div>
      )
  }

  return (
    <Container>
      <Card>
        <div className="d-flex align-items-center justify-content-between border-bottom py-2 px-3">
          <Card.Title className="mb-0">{t('batteriesList.title')}</Card.Title>
        </div>
        <Card.Body>{renderAsyncContent()}</Card.Body>
      </Card>
    </Container>
  )
}
